export default __webpack_public_path__ + "static/media/pensiones.7df768e0.png";